module.exports = __webpack_public_path__ + "static/media/logo_vbl.c0481f07.png";